import { withNavigationWatcher } from './contexts/navigation';
import { CorpListPage } from './main/corp-list';
import { CorpInfoPage } from './main/corp-info';
import { CardBillListPage } from './main/card-bill-list';
import { CallServiceSearchPage } from'./main/call-service-search';

const routes = [
  // {
  //   path: '/corp-list',
  //   component: CorpListPage,
  // },
  {
    path: '/corp-info',
    component: CorpInfoPage,
  },
  {
    path: '/card-bill-list',
    component: CardBillListPage,
  },
  {
    path: '/call-service-search',
    component: CallServiceSearchPage,
  },
];

const AppRoutes = routes.map((route) => {
  return {
    ...route,
    component: withNavigationWatcher(route.component),
  };
});

export default AppRoutes;
